import { getAttributeValues } from './attribute';

const ownerCategoryOptions = [
  { label: '- Choose One -', value: '' },
  { label: 'Glove Compartment Items', value: 'Glove Compartment Items' },
  { label: 'Miscellaneous', value: 'Miscellaneous' },
  { label: 'OM DVD', value: 'OM DVD' },
];

const ownerTypeOptions = [
  { label: '- Choose One -', value: '' },
  { label: '0000 - General', value: '0000 - General' },
  { label: 'Complete Wallets', value: 'Complete Wallets' },
  { label: 'Empty Wallets', value: 'Empty Wallets' },
  { label: 'Feature Videos', value: 'Feature Videos' },
  { label: 'Miscellaneous', value: 'Miscellaneous' },
  { label: 'Owner Manuals', value: 'Owner Manuals' },
  { label: 'Quick Guide', value: 'Quick Guide' },
  { label: 'Tire Warranties', value: 'Tire Warranties' },
  { label: 'Volvo On Call', value: 'Volvo On Call' },
  { label: 'Wallet Insert Packs', value: 'Wallet Insert Packs' },
  { label: 'Warranty Booklets', value: 'Warranty Booklets' },
];

const serviceCategoryOptions = [
  { label: '- Choose One -', value: '' },
  { label: 'Accessory Bulletins', value: 'Accessory Bulletins' },
  { label: 'Accessory Catalog CD', value: 'Accessory Catalog CD' },
  { label: 'Chemical', value: 'Chemical' },
  { label: 'Information Bulletins', value: 'Information Bulletins' },
  { label: 'Management Process Guide', value: 'Management Process Guide' },
  { label: 'Miscellaneous', value: 'Miscellaneous' },
  { label: 'Parts Bulletins', value: 'Parts Bulletins' },
  { label: 'Parts Catalog (Fiche)', value: 'Parts Catalog (Fiche)' },
  { label: 'Parts Catalog (Paper)', value: 'Parts Catalog (Paper)' },
  { label: 'Quality Bulletins', value: 'Quality Bulletins' },
  { label: 'Safety Data Bulletins', value: 'Safety Data Bulletins' },
  { label: 'Service Bulletins', value: 'Service Bulletins' },
  { label: 'Service Manager Bulletins', value: 'Service Manager Bulletins' },
  { label: 'Service Manuals', value: 'Service Manuals' },
  { label: 'Service Product Journals', value: 'Service Product Journals' },
  { label: 'Shop Equipment', value: 'Shop Equipment' },
  { label: 'Special Tools', value: 'Special Tools' },
  { label: 'Tech-NET Notes', value: 'Tech-NET Notes' },
  { label: 'Tech. Info. Bulletins', value: 'Tech. Info. Bulletins' },
  { label: 'Technical Journal', value: 'Technical Journal' },
  {
    label: 'Technical Training Bulletin',
    value: 'Technical Training Bulletin',
  },
  { label: 'Training Literature', value: 'Training Literature' },
  { label: 'VIDA', value: 'VIDA' },
  { label: 'Warranty', value: 'Warranty' },
];

const serviceTypeOptions = [
  { label: '- Choose One -', value: '' },
  { label: '0000 - General', value: '0000 - General' },
  {
    label: '1000 - Standard Parts - Service and Maintenance Material',
    value: '1000 - Standard Parts - Service and Maintenance Material',
  },
  { label: '2000 - Engine', value: '2000 - Engine' },
  {
    label: '3000 - Electrical System and Instrumentation',
    value: '3000 - Electrical System and Instrumentation',
  },
  { label: '4000 - Power Transmission', value: '4000 - Power Transmission' },
  { label: '5000 - Brakes', value: '5000 - Brakes' },
  {
    label: '6000 - Wheel Suspension and Steering',
    value: '6000 - Wheel Suspension and Steering',
  },
  {
    label: '7000 - Frame - Springs - Damping and Wheels',
    value: '7000 - Frame - Springs - Damping and Wheels',
  },
  { label: '8000 - Body and Interior', value: '8000 - Body and Interior' },
  {
    label: '9000 - Miscellaneous - Special Functions',
    value: '9000 - Miscellaneous - Special Functions',
  },
  {
    label: 'Accessories and Other Equipment',
    value: 'Accessories and Other Equipment',
  },
  { label: 'Accessory Catalog CD', value: 'Accessory Catalog CD' },
  { label: 'Audio', value: 'Audio' },
  { label: 'BULLETIN', value: 'BULLETIN' },
  { label: 'Binder', value: 'Binder' },
  { label: 'Care', value: 'Care' },
  { label: 'Comfort', value: 'Comfort' },
  { label: 'Comprehensive', value: 'Comprehensive' },
  { label: 'Management Process Guide', value: 'Management Process Guide' },
  { label: 'Miscellaneous', value: 'Miscellaneous' },
  { label: 'Paints', value: 'Paints' },
  { label: 'Parts Catalog Fiche', value: 'Parts Catalog Fiche' },
  { label: 'Parts Catalog Paper', value: 'Parts Catalog Paper' },
  { label: 'Patches', value: 'Patches' },
  { label: 'Personal', value: 'Personal' },
  { label: 'Primed Sheet Metal', value: 'Primed Sheet Metal' },
  { label: 'Replace', value: 'Replace' },
  { label: 'SRS Components', value: 'SRS Components' },
  { label: 'Safety', value: 'Safety' },
  { label: 'Service and Maintenance', value: 'Service and Maintenance' },
  { label: 'Set', value: 'Set' },
  { label: 'Shock Absorbers', value: 'Shock Absorbers' },
  {
    label: 'Shock Absorbers - Springs and Wheels',
    value: 'Shock Absorbers - Springs and Wheels',
  },
  { label: 'Shop Equipment Bulletin', value: 'Shop Equipment Bulletin' },
  { label: 'Special Tools Bulletins', value: 'Special Tools Bulletins' },
  { label: 'Sport', value: 'Sport' },
  { label: 'Tabs', value: 'Tabs' },
  { label: 'Training Manuals', value: 'Training Manuals' },
  { label: 'Travel', value: 'Travel' },
  { label: 'Update', value: 'Update' },
  { label: 'Vehicle Emission Campaigns', value: 'Vehicle Emission Campaigns' },
  { label: 'Weather', value: 'Weather' },
  { label: 'Wiring Diagrams', value: 'Wiring Diagrams' },
];

const modelOptions = [
  { label: '- Choose One -', value: '' },
  { label: '120', value: '120' },
  { label: '121', value: '121' },
  { label: '124', value: '124' },
  { label: '140', value: '140' },
  { label: '144', value: '144' },
  { label: '160', value: '160' },
  { label: '1800', value: '1800' },
  { label: '240', value: '240' },
  { label: '260', value: '260' },
  { label: '544-110-210', value: '544-110-210' },
  { label: '740', value: '740' },
  { label: '760', value: '760' },
  { label: '780', value: '780' },
  { label: '850', value: '850' },
  { label: '850GLT', value: '850GLT' },
  { label: '940', value: '940' },
  { label: '940GLE', value: '940GLE' },
  { label: '940SE', value: '940SE' },
  { label: '940T', value: '940T' },
  { label: '960', value: '960' },
  { label: 'C30', value: 'C30' },
  { label: 'C40BEV', value: 'C40BEV' },
  { label: 'C70', value: 'C70' },
  { label: 'OTHER', value: 'OTHER' },
  { label: 'S40', value: 'S40' },
  { label: 'S40SE', value: 'S40SE' },
  { label: 'S60', value: 'S60' },
  { label: 'S60CC', value: 'S60CC' },
  { label: 'S60i', value: 'S60i' },
  { label: 'S60MHEV', value: 'S60MHEV' },
  { label: 'S60PHEV', value: 'S60PHEV' },
  { label: 'S70', value: 'S70' },
  { label: 'S80', value: 'S80' },
  { label: 'S90', value: 'S90' },
  { label: 'S90MHEV', value: 'S90MHEV' },
  { label: 'S90PHEV', value: 'S90PHEV' },
  { label: 'V40', value: 'V40' },
  { label: 'V40SE', value: 'V40SE' },
  { label: 'V50', value: 'V50' },
  { label: 'V60', value: 'V60' },
  { label: 'V60CC', value: 'V60CC' },
  { label: 'V60PHEV', value: 'V60PHEV' },
  { label: 'V70', value: 'V70' },
  { label: 'V90', value: 'V90' },
  { label: 'V90CC', value: 'V90CC' },
  { label: 'V90CCMHEV', value: 'V90CCMHEV' },
  { label: 'XC40', value: 'XC40' },
  { label: 'XC40BEV', value: 'XC40BEV' },
  { label: 'XC60', value: 'XC60' },
  { label: 'XC60MHEV', value: 'XC60MHEV' },
  { label: 'XC60PHEV', value: 'XC60PHEV' },
  { label: 'XC70', value: 'XC70' },
  { label: 'XC90', value: 'XC90' },
  { label: 'XC90E', value: 'XC90E' },
  { label: 'XC90PHEV', value: 'XC90PHEV' },
];

const yearOptions = [
  { label: '- Choose One -', value: '' },
  { label: '2024', value: '2024' },
  { label: '2023', value: '2023' },
  { label: '2022', value: '2022' },
  { label: '2021', value: '2021' },
  { label: '2020', value: '2020' },
  { label: '2019', value: '2019' },
  { label: '2018', value: '2018' },
  { label: '2017', value: '2017' },
  { label: '2016', value: '2016' },
  { label: '2015.5', value: '2015.5' },
  { label: '2015', value: '2015' },
  { label: '2014', value: '2014' },
  { label: '2013', value: '2013' },
  { label: '2012', value: '2012' },
  { label: '2011', value: '2011' },
  { label: '2010', value: '2010' },
  { label: '2009', value: '2009' },
  { label: '2008', value: '2008' },
  { label: '2007', value: '2007' },
  { label: '2006', value: '2006' },
  { label: '2005', value: '2005' },
  { label: '2004.5', value: '2004.5' },
  { label: '2004', value: '2004' },
  { label: '2003', value: '2003' },
  { label: '2002', value: '2002' },
  { label: '2001', value: '2001' },
  { label: '2000', value: '2000' },
  { label: '1999', value: '1999' },
  { label: '1998', value: '1998' },
  { label: '1997', value: '1997' },
  { label: '1996', value: '1996' },
  { label: '1995', value: '1995' },
  { label: '1994', value: '1994' },
  { label: '1993', value: '1993' },
  { label: '1992', value: '1992' },
  { label: '1991', value: '1991' },
  { label: '1990', value: '1990' },
  { label: '1989', value: '1989' },
  { label: '1988', value: '1988' },
  { label: '1987', value: '1987' },
  { label: '1986', value: '1986' },
  { label: '1985', value: '1985' },
  { label: '1984', value: '1984' },
  { label: '1983', value: '1983' },
  { label: '1982', value: '1982' },
  { label: '1981', value: '1981' },
  { label: '1980', value: '1980' },
  { label: '1979', value: '1979' },
  { label: '1978', value: '1978' },
  { label: '1977', value: '1977' },
  { label: '1976', value: '1976' },
  { label: '1975', value: '1975' },
  { label: '1974', value: '1974' },
  { label: '1973', value: '1973' },
  { label: '1972', value: '1972' },
  { label: '1971', value: '1971' },
  { label: '1970', value: '1970' },
  { label: '1969', value: '1969' },
  { label: '1968', value: '1968' },
  { label: '1967', value: '1967' },
  { label: '1966', value: '1966' },
  { label: '1965', value: '1965' },
  { label: '1964', value: '1964' },
  { label: '1963', value: '1963' },
  { label: '1962', value: '1962' },
  { label: '1961', value: '1961' },
  { label: '1960', value: '1960' },
  { label: '1959', value: '1959' },
];

const apasTypeOptions = [
  { label: '- Choose One -', value: '' },
  { label: 'AM Accessories', value: 'AM Accessories' },
  { label: 'AM Assurance Products', value: 'AM Assurance Products' },
  { label: 'AM Merchandise', value: 'AM Merchandise' },
  { label: 'AM Parts', value: 'AM Parts' },
  { label: 'AM Service', value: 'AM Service' },
  { label: 'Accessory Bulletins', value: 'Accessory Bulletins' },
  { label: 'Miscellaneous', value: 'Miscellaneous' },
  { label: 'Sales', value: 'Sales' },
];

const fixedPrice = (price: string) => {
  let floatPrice = Number.parseFloat(price);

  if (isNaN(floatPrice)) {
    floatPrice = 0;
  }

  return floatPrice.toFixed(2);
};

const findFormat = (product) => {
  if (product.variants.length === 0) return [];
  return product.variants[0].name;
};

const findFormats = (product) => {
  if (product.variants.length === 0) return [];
  return product.variants.map((v) => v.name);
};

const isRetailer = (attributes) => {
  const attrs: string[] = getAttributeValues(attributes, 'purchaseoption');
  let hasConsumer = false;
  let hasRetailer = false;

  for (const attr of attrs) {
    if (attr === 'consumer') {
      hasConsumer = true;
    } else if (attr === 'internal_access') {
      hasRetailer = true;
    }
  }

  return !hasConsumer && hasRetailer;
};

const itemTypeToLibraryGroup = (type) => {
  if (
    type === 'Service Bulletins' ||
    type === 'Service Manager Bulletins' ||
    type === 'Special Tools' ||
    type === 'Parts Bulletins' ||
    type === 'Technical Training Bulletins'
  ) {
    return 'sb';
  }

  if (type === 'Safety Data Sheets') {
    return 'msds';
  }

  if (type === 'Technical Journal') {
    return 'tj';
  }

  if (type === 'Quality Bulletins') {
    return 'qb';
  }

  return '';
};

export {
  ownerCategoryOptions,
  ownerTypeOptions,
  serviceCategoryOptions,
  serviceTypeOptions,
  modelOptions,
  yearOptions,
  apasTypeOptions,
  fixedPrice,
  findFormat,
  findFormats,
  isRetailer,
  itemTypeToLibraryGroup,
};
